import { Skeleton } from "../ui/skeleton";

export default function HomeBannerLoader() {
  return (
    <div className="w-full h-[700px] bg-midnightIndigo-100 flex flex-col justify-center items-center p-4  ">
      <Skeleton className="h-[40px] bg-midnightIndigo-200 w-[600px] mb-4" />
      <Skeleton className="h-[25px] bg-midnightIndigo-200 w-[300px] mb-4" />
      <Skeleton className="h-[45px] bg-midnightIndigo-200 w-[125px]" />
    </div>
  );
}
